/*!
 * @piconetworks/badge v2.2.1
 * (c) 
 */
'use strict';

var cx = require('classnames');
var PropTypes = require('prop-types');
var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var cx__default = /*#__PURE__*/_interopDefaultLegacy(cx);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var style = {"badgeContainer":"Badge-module_badgeContainer__1Wsyt","badgeAlert":"Badge-module_badgeAlert__2v7n_","badgeTopRight":"Badge-module_badgeTopRight__1ARTV","badgeText":"Badge-module_badgeText__7gEbF","badgeBottom":"Badge-module_badgeBottom__nApk1","badgeLeft":"Badge-module_badgeLeft__1frQB","primary":"Badge-module_primary__1g3sv","focus":"Badge-module_focus__4XMZo","secondary":"Badge-module_secondary__2A6mu","success":"Badge-module_success__31e0y","info":"Badge-module_info__2PyDT","warning":"Badge-module_warning__2KxZb","danger":"Badge-module_danger__3FtAM","light":"Badge-module_light__2qnIK","dark":"Badge-module_dark__1UbIt","facebook":"Badge-module_facebook__1aXY3","github":"Badge-module_github__3dbzJ","google":"Badge-module_google__2P2Vy","linkedin":"Badge-module_linkedin__QrFAW","twitter":"Badge-module_twitter__1kBH8"};

var Badge = function Badge(_ref) {
  var children = _ref.children,
      className = _ref.className,
      bottomLabel = _ref.bottomLabel,
      topRightLabel = _ref.topRightLabel,
      badgeChildren = _ref.badgeChildren,
      variant = _ref.variant,
      leftLabel = _ref.leftLabel,
      props = _objectWithoutProperties(_ref, ["children", "className", "bottomLabel", "topRightLabel", "badgeChildren", "variant", "leftLabel"]);

  // square is equal parts width and height - ie an icon
  // text is going to vary in width
  var topRightContentType = topRightLabel && /*#__PURE__*/React__default['default'].isValidElement(topRightLabel) ? 'badgeSquare' : 'badgeText';
  var bottomContentType = bottomLabel && /*#__PURE__*/React__default['default'].isValidElement(bottomLabel) ? 'badgeSquare' : 'badgeText';
  var leftContentType = leftLabel && /*#__PURE__*/React__default['default'].isValidElement(leftLabel) ? 'badgeSquare' : 'badgeText';
  return /*#__PURE__*/React__default['default'].createElement("div", _extends({
    className: cx__default['default'](style.badgeContainer, variant && variant, className)
  }, props, {
    "data-testid": "Badge_index_div"
  }), badgeChildren && /*#__PURE__*/React__default['default'].createElement("span", {
    className: cx__default['default'](style.badgeText, style[variant]),
    "data-testid": "Badge_index_span"
  }, children), !badgeChildren && children, topRightLabel && /*#__PURE__*/React__default['default'].createElement("span", {
    className: cx__default['default'](style.badgeAlert, style.badgeTopRight, style[variant], topRightContentType, style[topRightContentType]),
    "data-testid": "Badge_index_span"
  }, topRightLabel), bottomLabel && /*#__PURE__*/React__default['default'].createElement("span", {
    className: cx__default['default'](style.badgeAlert, style.badgeBottom, style[variant], bottomContentType, style[bottomContentType]),
    "data-testid": "Badge_index_span"
  }, bottomLabel), leftLabel && /*#__PURE__*/React__default['default'].createElement("span", {
    className: cx__default['default'](style.badgeAlert, style[variant], style.badgeLeft, leftContentType, style[leftContentType]),
    "data-testid": "Badge_index_span"
  }, leftLabel));
};

Badge.propTypes = {
  badgeChildren: PropTypes__default['default'].bool,
  children: PropTypes__default['default'].node,
  className: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].object]),
  bottomLabel: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].node]),
  position: PropTypes__default['default'].string,
  topRightLabel: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].node]),
  variant: PropTypes__default['default'].string,
  leftLabel: PropTypes__default['default'].PropTypes.oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].node])
};
Badge.defaultProps = {
  badgeChildren: false
};

module.exports = Badge;
